import React, { useState } from 'react';
import PhotoUploader from './components/PhotoUploader';
import PixelArtCanvas from './components/PixelArtCanvas';
import ColorPalette from './components/ColorPalette';
import ConversionSettings from './components/ConversionSettings';
import './App.css';

function App() {
  const [uploadedImage, setUploadedImage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [settings, setSettings] = useState({
    width: 58,
    height: 58,
    contrast: 40,
    brightness: 0,
    saturation: 1.2,
    gamma: 1.1,
    useDithering: true,
    sharpen: true
  });

  return (
    <div className="min-h-screen bg-[#f1f5f9] font-sans text-slate-900">
      <header className="bg-slate-900 text-white h-20 flex items-center justify-between px-8 sticky top-0 z-50 shadow-2xl">
        <div className="flex items-center">
          <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl mr-4 shadow-lg rotate-3 flex items-center justify-center font-black text-xl">H</div>
          <div>
            <h1 className="text-xl font-black tracking-tighter">HAMA<span className="text-purple-400">PRO</span> STUDIO</h1>
            <p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest">Le convertisseur ultime</p>
          </div>
        </div>
        <div className="hidden md:flex items-center space-x-6 text-[11px] font-black uppercase tracking-widest text-slate-400">
          <a 
            href="https://perle-hama.fr/bases-conseils/pixel-art-bien-debuter-en-perles-hama/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-purple-400 cursor-pointer transition-colors"
          >
            Tutoriels
          </a>
          <span className="bg-purple-600 text-white px-4 py-2 rounded-full cursor-pointer hover:bg-purple-500 transition-all">
            Soutenir le projet
          </span>
        </div>
      </header>

      <main className="max-w-[1700px] mx-auto p-8 grid grid-cols-1 lg:grid-cols-12 gap-8">
        <aside className="lg:col-span-3 space-y-8">
          <PhotoUploader onImageUpload={setUploadedImage} isProcessing={isProcessing} />
          <ConversionSettings settings={settings} onSettingsChange={setSettings} />
          <ColorPalette />
        </aside>
        
        <section className="lg:col-span-9">
          <PixelArtCanvas 
            originalImage={uploadedImage} 
            settings={settings} 
            isProcessing={isProcessing} 
            onProcessingChange={setIsProcessing} 
          />
        </section>
      </main>

      <footer className="bg-white border-t border-slate-200 py-10 mt-20">
        <div className="max-w-[1700px] mx-auto px-8 flex flex-col md:flex-row justify-between items-center text-slate-400 text-sm font-medium">
          <p>© 2024 HamaPRO Studio - Créé pour les passionnés de Pixel Art</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="hover:text-purple-600">Confidentialité</a>
            <a href="#" className="hover:text-purple-600">Aide</a>
            <a href="#" className="hover:text-purple-600">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;